import { useLazyQuery } from '@apollo/client';
import Cookies from 'js-cookie';
import { useEffect, useRef } from 'react';

import { UserIdDocument as GET_SCRAMBLED_ID } from './user-id.gql-types';

export const useScrambledId = (): void => {
  const hasFetched = useRef(false);
  const [fetchScrambledId] = useLazyQuery(GET_SCRAMBLED_ID, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data?.viewer?.id) {
        Cookies.set('s_id2', data?.viewer?.id, {
          expires: 90,
          domain: 'xing.com',
        });
      }
    },
  });

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    try {
      fetchScrambledId();
    } catch (error) {
      console.error('Failed to fetch viewer data:', error);
    }
  }, [fetchScrambledId]);
};
